/**
 * How many lines `text` takes word-wrapped at `maxWidth` (as `setMaxWidth` wraps it), at body
 * size: every glyph is one 6 px cell. Lays out panels before their text is drawn.
 */
export function wrapLineCount(text: string, maxWidth: number, scale = 1): number {
  // Phaser measures each word with the space after it (all but the line's last word).
  const fits = Math.floor(maxWidth / (6 * scale));
  let lines = 0;
  for (const para of text.split('\n')) {
    lines++;
    const words = para.split(' ');
    let used = 0;
    words.forEach((w, k) => {
      const len = w.length + (k < words.length - 1 ? 1 : 0);
      if (used === 0 || used + len <= fits) used += len;
      else {
        lines++;
        used = len;
      }
    });
  }
  return lines;
}
